import { Currency, Math } from 'core/utils';


function getValue(xmlDoc: Document, elementName: string) {
	const xmlElements = xmlDoc.getElementsByTagName(elementName);
	return xmlElements.length === 0 ? null : xmlElements[0].childNodes[0].nodeValue;
}

export function getReference(xmlDetails: string): string {

	const parser = new DOMParser();
	const xmlDoc = parser.parseFromString(xmlDetails, 'text/xml');

	const paymentReference = getValue(xmlDoc, 'PspReference')
		|| getValue(xmlDoc, 'NumOpCO')
		|| getValue(xmlDoc, 'Factura')
		|| getValue(xmlDoc, 'PaymentOperation');

	if (paymentReference === null)
		throw new Error(`No se ha encontrado la referencia de pago en el XML: ${xmlDetails}`);

	return paymentReference;
}


export function getTip(xmlDetails: string): number {

	const parser = new DOMParser();
	const xmlDoc = parser.parseFromString(xmlDetails, 'text/xml');

	const tipValue = Math.round(Number(getValue(xmlDoc, 'TipAmount') || 0) / 100, Currency.DECIMAL_PLACES);
	return tipValue;
}